import { Message } from "rsuite";
import { useLocation } from "react-router-dom";

export default function PageNotFoundPage() {

  const location = useLocation();

  const innderStyle = () => {
    return { backgroundColor: 'white', height: '2000px' }
  }

  return (<div className="App" style={innderStyle()}>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <div style={{
      paddingLeft: '15px', paddingRight: '15px'
    }}>
      <Message showIcon type="error" header="Error">
        {location.pathname}<br></br>
        您所瀏覽的網頁不存在.
      </Message>
    </div>

  </div>)
}